import { OnInit } from '@angular/core';
var CsAgGridCellParagraphsRendererComponent = /** @class */ (function () {
    function CsAgGridCellParagraphsRendererComponent() {
        this.readMore = false;
        this.moreDetail = false;
        this.isExpanded = false;
        this.showMoreButton = false;
    }
    CsAgGridCellParagraphsRendererComponent.prototype.ngOnInit = function () {
        if (this.params.showMore) {
            if (this.params.showMore.type === 'readMore') {
                this.readMore = true;
            }
            if (this.params.showMore.type === 'moreDetails') {
                this.moreDetail = true;
            }
            this.showMoreButton = (this.params.showMore.showMoreButton) ? this.params.showMore.showMoreButton : false;
            this.limit = (this.params.showMore.limit) ? this.params.showMore.limit : 5;
        }
        else {
            this.limit = 'no';
        }
    };
    CsAgGridCellParagraphsRendererComponent.prototype.getStyles = function (limit, description) {
        if (limit == 'no') {
            this.readMore = false;
            this.isExpanded = true;
        }
        else {
            if (!this.isExpanded && limit > 0) {
                var length_1 = description ? description.length : 0;
                if (length_1 <= 0) {
                    this.readMore = false;
                    return null;
                }
                else {
                    if (length_1 <= 250) {
                        this.readMore = false;
                        return null;
                    }
                    else {
                        this.readMore = true;
                        return {
                            'display': '-webkit-box',
                            '-webkit-line-clamp': limit,
                            '-webkit-box-orient': 'vertical',
                            'overflow': 'hidden',
                            'text-overflow': 'ellipsis'
                        };
                    }
                }
            }
            else {
                this.readMore = false;
                return null;
            }
        }
    };
    CsAgGridCellParagraphsRendererComponent.prototype.onClick = function () {
        if (this.params.showMore.type == 'moreDetails') {
            this.params.showMore.onClick(this.params);
        }
        else {
            this.readMore = false;
            this.isExpanded = true;
        }
    };
    return CsAgGridCellParagraphsRendererComponent;
}());
export { CsAgGridCellParagraphsRendererComponent };
